
import { appSender, downloaderSender } from '@/api/anycubic_axios';


class Application {

    /**
     * @brief 打印日志到文件
     *     enum LogLevel {
                LevInfo = 0, ///< 信息
                LevWar = 1,      ///< 警告
                LevErr = 2,      ///< 错误
                LevFail = 3     ///< 失败
            };
     * 
     * @param level 日志级别
     * @param message 日志信息
     * @returns 成功返回0,失败返回错误代码
     */
    async log(level, message) {
        let response = -1
        await appSender.post("log", { "level": level, "message": message }).then((res) => response = res)
        return response;
    }

    /**
     * @brief 显示toast提示
     * 
     * @param postion 位置 -- 当前仅实现 `RightBottom`
     *     enum ShowPostion  {
                  LeftTop = 0, ///< 左上角
                  LeftBottom=1,  ///< 左下角
                  RightTop=2,    ///< 右上角
                  RightBottom=3, ///< 右下解
                  Center      =4 ///< 居中
              };
     * @param type 类型
                enum MessagetType {
                        Information = 0, ///< 消息
                        Warning = 1,         ///< 警告
                        Error = 2,           ///< 错误
                        Fail = 3          ///< 失败
                    };
     * @param timeout 超时时间
     * @param title 标题
     * @param message 内容
     * @param msg_type 内容类型 1： TEXT 2：HTML -- 2024-08-06 新增
     * @param id 唯一标识，用于标记当次调用 -- 2024-08-15 新增
     * @param btns 按钮组合,eg:BtnOk|BtnCancel|BtnEnter, 最大组合三个按钮 -- 2024-09-29 新增 
    *       enum BtnId{
                BtnNone = 0b00,        ///< 无按钮
                BtnOk = 0b01,          ///< 好
                BtnCancel = 0b10,      ///< 取消
                BtnYes = 0b100,        ///< 是
                BtnNo = 0b1000,        ///< 否
                BtnAccept = 0b10000,   ///< 接受
                BtnDecline = 0b100000, ///< 拒绝
                BtnEnter = 0b1000000   ///< 确定
            }
     * @returns 成功返回0,失败返回错误代码
     */
    async show_toast(postion, type, timeout, title, message, msg_type, id, btn) {
        let response = -1
        await appSender.post("show_toast", {
            "postion": postion, "type": type,
            "timeout": timeout, "title": title, "message": message, "msg_type": msg_type, "id": id, "btn": btn
        }).then((res) => response = res)
        return response;
    }
    /**
     * @brief 显示toast提示
     * 
     * @param type 类型
     * @param title 标题
     * @param message 内容
     * @param msg_type 内容类型 1： TEXT 2：HTML -- 2024-08-06 新增
     * @param id 唯一标识，用于标记当次调用 -- 2024-08-15 新增
     * @param btns 按钮组合,eg:BtnOk|BtnCancel|BtnEnter , 最大组合三个按钮 -- 2024-09-29 新增
     * @returns 成功返回0,失败返回错误代码
     */
    async show_box(type, title, message, msg_type, id, btns) {
        let response = -1;
        await appSender.post("show_box", {
            "type": type, "title": title, "message": message, "msg_type": msg_type, "id": id, "btns": btns
        }).then((res) => response = res)
        return response;
    }

    /**
     * @brief 配置读取
     * 
     * @param key 配置项名称 (eg:key1.key2.key3)
     * @returns 配置项值
     */
    async config_read(key) {
        const response = await appSender.get("config_read", { "key": key })
        return response.data;
    }
    /**
     * @brief 配置读取
     * 
     * @param key 配置项名称 (eg:key1.key2.key3)
     * @param value 配置项值
     * @returns 成功返回0,失败返回错误代码
     */
    config_write(key, value) {
        const response = appSender.post("config_write", { "key": key, "value": String(value) })
        return response.data;
    }
    /**
     * @brief 配置删除
     * 
     * @param key 配置项名称 (eg:key1.key2.key3)
     * @returns 成功返回0,失败返回错误代码 
     */
    async config_remove(key) {
        let response = -1
        await appSender.del("config_remove", { "key": key }).then((res) => response = res)
        return response;
  }
  // 软件跳转处理
  async common_notify () {
      let response = -1
      await appSender.post("common_notify", { script: 'window.sliceJumpWorkbench' }).then((res) => response = res)
      return response;
    }
    async set_show_notify(func) {
        window.show_notify = func
        let response = -1
        await appSender.post('show_notify', { script: 'window.show_notify' }).then(res => response = res)
        return response
    }
    async import_model(file_path, type) {
        let response = -1
        await downloaderSender.post("import_model", { "file_path": file_path, "import_type": type }).then((res) => response = res)
        return response;
    }
    async open_model_dir(file_path) {
        let response = -1
        await downloaderSender.post("open_model_dir", { "file_path": file_path }).then((res) => response = res)
        return response;
    }
}


export function createApplication() {
    return new Application;
}